<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="custom-dialog" class="count-result" :close-on-click-modal="false" append-to-body width="500px">
    <div slot="title" class="title">
      <div class="title-name">生成报告前，有以下内容需要确认</div>
      <div class="side-title"></div>
      <div class="dialog-close-btn" @click="dialogVisible = false">X</div>
    </div>
    <div class="count-result-box">
      <p class="mb10">【第二页：综述】</p>
      <p class="mb10">过去一年里，</p>
      <p class="mb10">您一共向我们委托了【{{ projectCount || 0 }}】个岗位</p>
      <el-input v-for="(item,index) in showProjects" :key="`${index}`" v-model="showProjects[index]" class="mb10" size="mini" placeholder="请输入内容"></el-input>
      <br>
      <br>
      <p class="mb10">【第三页：职位】</p>
      <p class="mb10">合作最成功的项目</p>
      <el-input v-model="projectName1" class="mb10" size="mini" placeholder="请输入内容"></el-input>
      <p class="mb10">合作最艰难的项目</p>
      <el-input v-model="projectName2" class="mb10" size="mini" placeholder="请输入内容"></el-input>
    </div>
    <div class="count-result-footer">
      <el-button class="mr10" style="flex: none" size="mini" type="primary" @click="confirm">确认生成报告</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      projectCount: 0,
      showProjects: ['','','','',''],
      projectName1: '',
      projectName2: '',
    }
  },
  methods: {
    open(option) {
      this.loading = false
      this.projectCount = 0
      this.showProjects = ['','','','','']
      this.reportOption = option
      const lastYear = new Date(`${new Date().getFullYear() - 1}`).getTime()
      const thisYear = new Date(`${new Date().getFullYear()}`).getTime()
      this.reportOption.timeRange = [lastYear,thisYear]
      this.reportOption.年份 = new Date(lastYear).getFullYear()
      this.getCompanyProjects()
      this.dialogVisible = true
    },
    async getCompanyProjects(){
      const res = await app.service('misc').getClientYearProjects({ company: this.reportOption.公司, timeRange: this.reportOption.timeRange })
      if(res.status==='success'){
        const projects = res.data
        let num = 3
        if(projects.length < 3) num = projects.length
        const arr = []
        for(let i = 0;i<num;i+=1){
          arr.push(projects[i].项目名称)
        }
        this.showProjects = arr
        this.projectCount = projects.length
      } else this.$message.error(res.msg)
    },
    async getClientYearReport(){
      if(this.loading) return this.$message.error('生成报告中，请稍候')
      this.loading = true
      const res = await app.service('misc').getClientYearReport(this.reportOption)
      if(res.status==='success'){
        const result = res.data
        app.root.$refs.ModifyClientYearReportDialog.open(result)
        this.dialogVisible = false
        // app.root.$refs.GetClientYearReportDialog.open(result)
      } else this.$message.error(res.msg)
      this.loading = false
    },
    confirm(){
      try {
        this.reportOption.项目名称 = this.showProjects
        this.reportOption.最成功的项目 = this.projectName1
        this.reportOption.最艰难的项目 = this.projectName2
        this.getClientYearReport()
      } catch (e) {
        console.log(e.message);
      }
    },
  },
}
</script>
<style>
.custom-dialog .el-dialog__body {
  padding-top: 0px;
}
.count-result-footer .el-button--primary  {
  background-color: #4394b9;
  border-color: #4394b9;
}
</style>
<style scoped src="../../company/statistics/css/commonCompany.css"></style>
<style scoped>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height:1.5;
  margin: 0;
  padding:15px
}
.title-btn {
  margin-left: 30px;
  color: #cbcbcb;
  font-size: 14px;
  cursor: pointer;
}
.count-result-box{
  padding: 0 30px;
}
.count-result-footer{
  display: flex;
  justify-content: center;
}
</style>
